import { _js } from '@ifixit/utils/localize';
import styled from 'styled-components';
import { space, color, borderRadius, fontSize, breakpoint } from '@ifixit/primitives';

const VideoContainer = styled.div`
   display: flex;
   margin: ${space[10]} ${space[0]} ${space[0]};
   border-radius: ${borderRadius.lg};
   background-color: ${color.gray[900]};
   overflow: hidden;

   @media only screen and (max-width: ${breakpoint.md}) {
      flex-direction: column;
      margin-top: ${space[7]};
   }
`;

const Video = styled.div`
   width: 50%;
   position: relative;

   @media only screen and (max-width: ${breakpoint.md}) {
      width: 100%;
      height: 300px;
   }
`;

const VideoIFrame = styled.iframe`
   position: absolute;
   width: 100%;
   height: 100%;
`;

const VideoText = styled.div`
   width: 50%;
   display: flex;
   flex-direction: column;
   justify-content: space-between;
   align-items: flex-start;
   color: ${color.white};
   padding: ${space[8]} ${space[10]};
   margin: ${space[5]} ${space[0]};

   @media only screen and (max-width: ${breakpoint.md}) {
      padding: ${space[6]} ${space[8]};
      width: 100%;
      height: 50%;
   }
`;

const VideoTitle = styled.h3`
   font-size: ${fontSize['3xl']};
   font-weight: 700;
   margin: ${space[0]};
   color: ${color.white};
`;

const VideoDescription = styled.p`
   font-size: ${fontSize.lg};
   color: ${color.gray[300]};
   margin: ${space[4]} ${space[0]};
   width: 100%;
`;

function getVideoLink(lang) {
   const videoId = langid => {
      switch (langid) {
         case 'tr': {
            return '4xNbqaUK2lE';
         }
         case 'pt': {
            return 'bE58x0W1qiA';
         }
         case 'nl': {
            return '5H2rho-f1Po';
         }
         case 'ko': {
            return 'vX2SNHgUfak';
         }
         case 'jp': {
            return 'ljBGH5F-bHA';
         }
         case 'it': {
            return 'ofd5QDCl-H8';
         }
         case 'fr': {
            return '3I1m06KkcIs';
         }
         case 'es': {
            return 'Tfs4WPcu0Vo';
         }
         case 'de': {
            return 'Ahd_VOlB83M';
         }
         default: {
            return 'O7CSWHVTUT8';
         }
      }
   };

   lang = lang.toLowerCase();
   return 'https://www.youtube-nocookie.com/embed/' + videoId(lang) + '?&rel=0';
}

const VideoDisplay = ({ links }) => (
   <VideoContainer>
      <VideoText>
         <VideoTitle>{_js('Contribute to iFixit')}</VideoTitle>
         <VideoDescription>
            {_js(
               'No one knows how to fix everything, but everyone \
                        knows how to fix something. Teach us what you know \
                        and make sure things work longer! The easier it is \
                        to fix something, the more people will do it.'
            )}
         </VideoDescription>
         <button
            type="button"
            onClick={() => (window.location.href = links.newPage)}
            className="inline-flex h-9 cursor-pointer items-center justify-center self-start rounded-lg border border-gray-700 bg-white px-4 font-semibold text-gray-800 transition-all duration-300 hover:text-black"
         >
            {_js('Start a New Page')}
         </button>
      </VideoText>
      <Video>
         <VideoIFrame
            src={getVideoLink(App.lang)}
            frameBorder="0"
            title="How To Write a Repair Guide on iFixit.com!"
         ></VideoIFrame>
      </Video>
   </VideoContainer>
);

export default VideoDisplay;
